// extracted by mini-css-extract-plugin
module.exports = {"cardSlider":"components-ItineraryCardSlider-ItineraryCardSlider__cardSlider--33Pgs","loadingCard":"components-ItineraryCardSlider-ItineraryCardSlider__loadingCard--chZcZ"};